// initial state
const state = {
  listOfReleases: [],
  // default release
  defaultRelease: {},
  // current selected release
  selectedRelease: {},
  lociNb: 0,
};

// getters
const getters = {
  getSelectedRelease: state => {
    return state.selectedRelease;
  },
  getSelectedReleaseId: state => {
    if (state.selectedRelease) {
      return state.selectedRelease.id;
    }
    return '';
  },
  getSelectedReleaseName: state => {
    if (state.selectedRelease) {
      return state.selectedRelease.label;
    }
    return '';
  },
  getSelectedReleaseDate: state => {
    if (state.selectedRelease) {
      return state.selectedRelease.date;
    }
    return '';
  },
  getDefaultRelease: state => {
    return state.defaultRelease;
  },
  getReferenceNames: state => {
    if (state.selectedRelease && state.selectedRelease.references) {
      return state.selectedRelease.references.map(r => r.name);
    } else {
      return [];
    }
  },
  getGenotypes: state => {
    if (state.selectedRelease && state.selectedRelease.genotypes) {
      return state.selectedRelease.genotypes;
    } else {
      return [];
    }
  },
  /**
   * return the release object with the id "id"
   * return undefined of not found
   * @param {*} state
   */
  getRelease(state) {
    return id => {
      return state.listOfReleases.find(s => s.id == id);
    };
  },
  getReleaseUrl(state, getters) {
    if (state.selectedRelease) {
      return getters.getUrlBase + getters.getCurrentSpecies + '/' + getters.getSelectedReleaseId;
    } else return '';
  },
  getLinksByLoci: state => id => {
    if (state.selectedRelease) {
      return state.selectedRelease.references
        .map(r => {
          return r.links.map(link => {
            return {
              descr: link.label,
              url: link.url.replace('%locus_id%', id),
              private: link.private,
            };
          });
        })
        .flat();
    } else {
      return [];
    }
  },
  /**
   * return a list of objects, composed of 2 keys: text and value
   * Useful in a v-select component
   */
  getAvailableReleaseItems: state => {
    return state.listOfReleases.map(r => {
      return { text: r.label, value: r.id };
    });
  },
};

import axios from 'axios';
// actions
const actions = {
  /**
   *
   * @param {*} param0
   * @param {*} r : id of the release to load
   */
  loadRelease({ commit, rootGetters }, r) {
    const baseMessage = 'Error during loading release';

    return new Promise((resolve, reject) => {
      axios
        .get(rootGetters.getUrlBase + rootGetters.getCurrentSpecies + '/' + r)
        .then(
          resp => {
            if (resp.data.error === true) {
              commit('setErrored', true, { root: true });
              let message = resp.data.message
                ? baseMessage + ': ' + resp.data.message
                : baseMessage;
              commit('setErrorMsg', message, { root: true });
            } else {
              commit('setSelectedRelease', resp.data);
              commit('setLociNb', resp.data.loci);
            }

            resolve(resp);
          },
          err => {
            commit('setErrored', true, { root: true });
            let message = err.response.data.message
              ? baseMessage + ': ' + err.response.data.message
              : baseMessage;
            commit('setErrorMsg', message, { root: true });
            reject(err);
          }
        )
        .catch(() => {
          commit('setErrored', true, { root: true });
          commit('setErrorMsg', baseMessage, { root: true });
          console.log('Error during loading release');
        });
    });
  },
  /**
   * reinitialize the current release
   * @param {*} param0
   */
  initRelease({ commit }) {
    commit('setSelectedRelease', {});
    commit('setDefaultRelease', {});
    commit('setLociNb', 0);
    commit('updateDefaultRelease', []);
  },
  /**
   * Get the accessible list of releases
   * @param {*} param0
   */
  fetchListOfReleases({ commit, rootGetters }) {
    const baseMessage = 'Error during fetching list of releases';

    return new Promise((resolve, reject) => {
      axios
        .get(rootGetters.getUrlBase + rootGetters.getCurrentSpecies + '/releases')
        .then(
          resp => {
            if (resp.data.error === true) {
              commit('setErrored', true, { root: true });
              let message = resp.data.message
                ? baseMessage + ': ' + resp.data.message
                : baseMessage;
              commit('setErrorMsg', message, { root: true });
            } else {
              commit('setListOfReleases', resp.data);
              commit('updateDefaultRelease', resp.data);
            }
            resolve(resp);
          },
          err => {
            commit('setErrored', true, { root: true });
            let message = err.response.data.message
              ? baseMessage + ': ' + err.response.data.message
              : baseMessage;
            commit('setErrorMsg', message, { root: true });
            reject(err);
          }
        )
        .catch(() => {
          commit('setErrored', true, { root: true });
          commit('setErrorMsg', baseMessage, { root: true });
          console.log(baseMessage);
        });
    });
  },
};

// mutations
const mutations = {
  setListOfReleases(state, l) {
    state.listOfReleases = l;
    console.log('new releases:');
    console.log(state.listOfReleases);
  },
  /**
   * search the current release
   * @param {*} state
   * @param {*} l List of available release objects
   */
  updateDefaultRelease(state, l) {
    var r = l.find(r => r.is_current === true);
    if (r) {
      state.defaultRelease = r;
    } else {
      state.defaultRelease = {};
    }
  },
  setDefaultRelease(state, r) {
    state.defaultRelease = r;
  },
  setSelectedRelease(state, r) {
    state.selectedRelease = r;
  },
  setLociNb(state, n) {
    state.lociNb = n;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
